import { useState } from 'react';

import { randomString } from 'shared/utils/string';

export const useRandomId = () => {
  const [val] = useState(randomString);
  return val;
};
